module.exports = __webpack_public_path__ + "src/img/note.912e7e6c.svg";